import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static outlets = ['wip--side-bar']
  static targets = ['frame']

  show(event) {
    event.preventDefault()

    const url = event.params.url
    if (!url) return

    const frame = this.frame
    const sidebarOpen = this.hasWipSideBarOutlet && this.wipSideBarOutlet.isOpen()
    const sameUrl = frame && frame.src === new URL(url, window.location.origin).href

    if (sidebarOpen && sameUrl) {
      this.wipSideBarOutlet.close()
      return
    }

    if (frame) {
      frame.src = url
    }

    if (this.hasWipSideBarOutlet && !sidebarOpen) {
      this.wipSideBarOutlet.open()
    }
  }

  // Targets are scope-limited, but a trigger area can live anywhere on the
  // page while the drawer's frame is rendered at the layout level — fall back
  // to the frame inside the sidebar the outlet points at.
  get frame() {
    if (this.hasFrameTarget) return this.frameTarget
    if (this.hasWipSideBarOutlet) return this.wipSideBarOutlet.element.querySelector('turbo-frame')

    return null
  }
}
